import { Auth } from './authLayout';
import Main from './main';

export const Layouts = {
  Auth,
  Main,
};
